import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import { Form, Formik, FormikProps } from 'formik';

import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';
import { eventToLink } from '@app/components/LocalCommon/Utils/eventToLink';
import '@app/scss/components/blockSideBar.scss';

interface SidebarProps {
	onSetIssue: any;
	navCollapse: boolean;
	topics: any;
	withSubmit: boolean;
	searchFieldName?: string;
	searchFieldPlaceHolder?: string;
	topicsInner?: any;
	submitCaption?: string;
	onSubmit?: (e: string) => void;
	typeTopicsInner?: string;
	isSearchFieldNeeded?: boolean;
	typePage?: string;
	searchFieldValue?: string;
	setSearchFieldValue?: (e: string) => void;
}

export const additionalResources = [
	{
		name: 'HowIKnow',
		url: 'how-will-i-know-it-is-time',
		title: "How Will I Know It's Time",
	},
	{
		name: 'Calendar',
		url: 'quality-of-life-calendar.pdf',
		title: 'Pet Quality of Life Calendar',
	},
	{
		name: 'Newsletter',
		url: 'newsletter',
	},
	{
		name: 'Blog',
		url: 'blog',
	},
	{
		name: 'Videos',
		url: 'videos',
	},
	{
		name: 'FAQ',
		url: 'faq',
	},
];

const SidebarWithCaptions: React.FC<SidebarProps> = ({
	searchFieldName = '',
	searchFieldPlaceHolder = '',
	onSetIssue,
	navCollapse,
	topics,
	onSubmit,
	typeTopicsInner,
	topicsInner,
	isSearchFieldNeeded = true,
	typePage = '',
	searchFieldValue,
	setSearchFieldValue,
}) => {
	const debounceTimer = React.useRef<NodeJS.Timeout | null>(null);

	const debouncedSubmit = React.useCallback((value: string) => {
		if (debounceTimer.current) {
			clearTimeout(debounceTimer.current);
		}

		debounceTimer.current = setTimeout(() => {
			onSubmit && onSubmit(value);
		}, 800);
	}, [onSubmit]);

	React.useEffect(() => {
		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, []);

	return (
		<div className="block__sidebar">
			<Formik onSubmit={(values) => {}} initialValues={{ searchQuery: '' }}>
				{(formikBag: FormikProps<any>) => {
					return (
						<Form autoComplete="off">
							{isSearchFieldNeeded && (
								<SearchFieldAuto
									name="searchQuery"
									placeholder={searchFieldPlaceHolder}
									formikBag={formikBag}
									onSelect={(value, option) => {}}
									onChange={(value) => {
										formikBag.setFieldValue('searchQuery', value);
										setSearchFieldValue && setSearchFieldValue(value);

										if (!value) {
											onSubmit && onSubmit('');
											return;
										}

										debouncedSubmit(value);
									}}
									onSearch={() => {
										searchFieldValue ? onSubmit && onSubmit(searchFieldValue) : null;
									}}
									searchButton
									buttonType="submit"
									allowClear
									label={searchFieldValue}
								/>
							)}
							<div className="block__sidebar-nav">
								{topics && topics.length > 0 && (
									<ul className="block__sidebar-nav-list sidebar-menu">
										{typePage === 'NEWS_PAGE' && (
											<li className="sidebar-menu__section">
												<h6 className="sidebar-menu__section-title block__sidebar-nav-list-caption">In the News</h6>
												<ul className="sidebar-menu__section-content">
													{topics.map((item, indexInner) => (
														<li key={indexInner} className="sidebar-menu__section-content__item">
															<NavLink
																to={`/in-the-news/${item.url}`}
																className={({ isActive }) => `sidebar-menu__section-content__item-link ${isActive ? 'active' : ''}`}
																onClick={() => {
																	onSetIssue(item);
																}}
																end
															>
																{item.name}
															</NavLink>
														</li>
													))}
												</ul>
											</li>
										)}
										{typePage === 'VET_FAQ' && (
											<>
												<li className="sidebar-menu__section">
													<h6 className="sidebar-menu__section-title block__sidebar-nav-list-caption">Veterinary Access</h6>
													<ul className="sidebar-menu__section-content">
														<li className="sidebar-menu__section-content__item">
															<Link
																to="/veterinary-resources/login"
																className="sidebar-menu__section-content__item-link"
															>
																Login
															</Link>
														</li>
													</ul>
												</li>
												<li className="sidebar-menu__section">
													<h6 className="sidebar-menu__section-title block__sidebar-nav-list-caption">
														Veterinary Resources
													</h6>
													<ul className="sidebar-menu__section-content">
														{topics.map((item, indexInner) => (
															<li key={indexInner} className="sidebar-menu__section-content__item">
																<NavLink
																	to={`${item.url}`}
																	className={({ isActive }) => `sidebar-menu__section-content__item-link ${isActive ? 'active' : ''}`}
																	onClick={() => {
																		onSetIssue(item);
																	}}
																	end
																>
																	{item.name}
																</NavLink>
															</li>
														))}
													</ul>
												</li>
											</>
										)}
										{!typePage && (
											<>
												<li className="sidebar-menu__section">
													<h6 className="sidebar-menu__section-title block__sidebar-nav-list-caption">
														Resource Topics
													</h6>
													<ul className="sidebar-menu__section-content">
														{topics.map((item, indexInner) => (
															<li key={indexInner} className="sidebar-menu__section-content__item">
																<NavLink
																	to={`/resource-center/${item.url}`}
																	className={({ isActive }) => `sidebar-menu__section-content__item-link ${isActive ? 'active' : ''}`}
																	onClick={() => {
																		onSetIssue.Common(item);
																	}}
																	end
																>
																	{item.name}
																</NavLink>
															</li>
														))}
													</ul>
												</li>
												<li className="sidebar-menu__section">
													<h6 className="sidebar-menu__section-title block__sidebar-nav-list-caption">
														Additional Resources
													</h6>
													<ul className="sidebar-menu__section-content">
														{additionalResources.map((resource, indexInner) => (
															<li key={indexInner} className="sidebar-menu__section-content__item">
																{resource.url !== 'quality-of-life-calendar.pdf' ? (
																	<NavLink
																		to={`/${resource.url}`}
																		className={({ isActive }) => `sidebar-menu__section-content__item-link ${isActive ? 'active' : ''}`}
																		onClick={() => {
																			onSetIssue[resource.name](resource);
																		}}
																		end
																	>
																		{resource.title ? resource.title : resource.name}
																	</NavLink>
																) : (
																	<Link
																		to={`/${resource.url}`}
																		target="_blank"
																		className="sidebar-menu__section-content__item-link"
																		onClick={() => {
																			onSetIssue[resource.name](resource);
																			eventToLink(resource.title ? resource.title : resource.name);
																		}}
																	>
																		{resource.title ? resource.title : resource.name}
																	</Link>
																)}

																{typeTopicsInner && topicsInner && resource.url === typeTopicsInner && (
																	<ul className="sidebar-menu__section-content sidebar-menu__section-content--second-level">
																		{topicsInner[resource.name] ? (
																			topicsInner[resource.name].map((topic, indexInner) => {
																				return (
																					<li
																						key={indexInner}
																						className="sidebar-menu__section-content__item"
																					>
																						<NavLink
																							to={`/${
																								resource.url
																							}/${topic.name
																								.toLowerCase()
																								.replace(/[&]/g, 'and')
																								.replace(/\s+/g, '-')}`}
																							className={({ isActive }) => `sidebar-menu__section-content__item-link ${isActive ? 'active' : ''}`}
																							onClick={() => {
																								onSetIssue[resource.name](topic);
																							}}
																							end
																						>
																							{topic.name}
																						</NavLink>
																					</li>
																				);
																			})
																		) : null}
																	</ul>
																)}
															</li>
														))}
													</ul>
												</li>
											</>
										)}
									</ul>
								)}
							</div>
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default SidebarWithCaptions;
